/* Lighting Reimagined — AJAX cart drawer
   Uses Shopify Cart API (/cart/add.js, /cart/change.js, /cart.js).
   Re-renders the drawer via Section Rendering API. */

(function () {
  'use strict';

  var drawer = null;

  function getDrawer() {
    if (!drawer) drawer = document.querySelector('[data-cart-drawer]');
    return drawer;
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = d.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=lr-cart-drawer')
      .then(function (r) {
        if (!r.ok) throw new Error('Section render failed: ' + r.status);
        return r.json();
      })
      .then(function (sections) {
        var html = sections['lr-cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = document.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        updateBubble(doc);
      })
      .catch(function () { /* network hiccup: fall back to current markup */ })
      .finally(function () {
        if (openAfter) openDrawer();
      });
  }

  function updateBubble(doc) {
    var freshBubble = doc.querySelector('[data-cart-count]');
    var bubbles = document.querySelectorAll('[data-cart-count]');
    bubbles.forEach(function (b) {
      if (freshBubble) {
        b.textContent = freshBubble.textContent;
        b.hidden = freshBubble.hidden || freshBubble.textContent.trim() === '0';
      }
    });
  }

  function addToCart(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    /* Open triggers */
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshDrawer(true);
      return;
    }
    /* Close triggers */
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-backdrop]')) {
      closeDrawer();
      return;
    }
    /* Quick add (product cards) */
    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      quickAdd.disabled = true;
      addToCart({ id: parseInt(quickAdd.getAttribute('data-quick-add'), 10), quantity: 1 })
        .then(function () { return refreshDrawer(true); })
        .catch(function (err) { alert((err && err.description) || 'Unable to add to cart.'); })
        .finally(function () { quickAdd.disabled = false; });
      return;
    }
    /* Drawer line quantity +/- and remove */
    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn) {
      var key = lineBtn.getAttribute('data-line-key');
      var qty = parseInt(lineBtn.getAttribute('data-line-change'), 10);
      changeLine(key, qty)
        .then(function () { return refreshDrawer(false); })
        .catch(function (err) { alert((err && err.description) || 'Unable to update cart.'); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Product form AJAX submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    var data = new FormData(form);
    addToCart({
      id: parseInt(data.get('id'), 10),
      quantity: parseInt(data.get('quantity') || '1', 10)
    })
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) { alert((err && err.description) || 'Unable to add to cart.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* Product page: variant radios swap price / availability / id */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-variant-radio]');
    if (!radio) return;
    var form = document.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput) idInput.value = radio.value;
    var price = document.querySelector('[data-variant-price]');
    if (price && radio.getAttribute('data-price')) price.innerHTML = radio.getAttribute('data-price');
    var stock = document.querySelector('[data-variant-stock]');
    if (stock) {
      var available = radio.getAttribute('data-available') === 'true';
      stock.querySelector('.stock-dot').classList.toggle('stock-dot--low', !available);
      stock.querySelector('[data-stock-text]').textContent = available
        ? stock.getAttribute('data-text-available')
        : stock.getAttribute('data-text-unavailable');
      var submit = form && form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? submit.getAttribute('data-text-add') : submit.getAttribute('data-text-soldout');
      }
    }
  });
})();
